import React from 'react';
import { Badge } from '@/features/shared/components/ui/badge';
import type { StatusMeta } from '../lib/state';

interface StatusChipProps {
  meta?: StatusMeta;
  className?: string;
}

/** Renders a consistent status pill from a centralised StatusMeta (see lib/state).
 *  Falls back to a neutral pill if meta is missing, so an unmapped status can
 *  never crash the page. */
export const StatusChip: React.FC<StatusChipProps> = ({ meta, className }) => {
  const safe = meta ?? { label: 'Unknown', variant: 'secondary' as const };
  return (
    <Badge variant={safe.variant as any} className={className}>
      {safe.label}
    </Badge>
  );
};
